import React from "react";
import { useTranslation } from "react-i18next";
import { InstitutePortalBuildingIcon } from "@components/icons/InstitutePortalBuildingIcon";
import "./HeaderBranding.css";

/** App bar title — INSTITUTE PORTAL with building icon (per dashboard shell design). */
export const HeaderBranding: React.FC<{ className?: string }> = ({ className = "" }) => {
	const { t } = useTranslation();

	return (
		<div className={`header-branding ${className}`}>
			<InstitutePortalBuildingIcon className="header-branding__icon shrink-0" />
			<h1 id="project-title" className="header-branding__title font-sans">
				{t("layout.header.portalTitle")}
			</h1>
		</div>
	);
};
